<template>
    <svg viewBox="0 0 16 16" width="16" height="16">
        <g>
            <path d="M3 14.5A1.5 1.5 0 0 1 1.5 13V3A1.5 1.5 0 0 1 3 1.5h8a.5.5 0 0 1 0 1H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V8a.5.5 0 0 1 1 0v5a1.5 1.5 0 0 1-1.5 1.5H3z"></path>
            <path d="M 4.583 6.502 C 4.384 6.277 4.502 5.92 4.797 5.86 C 4.823 5.855 4.849 5.852 4.876 5.852 L 11.124 5.852 C 11.425 5.852 11.613 6.177 11.463 6.438 C 11.449 6.461 11.434 6.482 11.416 6.502 L 8.292 10.017 C 8.137 10.192 7.863 10.192 7.708 10.017 L 4.583 6.502 Z"></path>
        </g>
    </svg>
</template>